import utils from '../common/util.js';

const cmpQuestionContainer = {
    component: null,

    /**
     * Initialise the Question Container
     * @param element
     */
    init: function (element)
    {
        utils.log('cmpQuestionContainer initiated : #' + element.id, 'info');

        const _ = utils.setEnvironment(this);

        _.component = element;
    },

    /**
     * Brings the question container into view
     */
    showQuestionContainer: function ()
    {
        const _ = this;

		utils.animateAndShow(_.questionContainer, 'opacity-0');
    },

    /**
     * Hides the question container from the view
     */
    hideQuestionContainer: function ()
    {
        const _ = this;

        utils.showHideElement(_.questionContainer, 'hide');
        _.questionContainer.classList.add('opacity-0');
    },

    /**
     * Add text to the question container
     */
    setQuestionText: function (title, text)
    {
        const _ = this;

        let questionText = '';
        if (title !== '') {
            questionText += '<div id="cmp-game-play__question-container__title">' + title + '</div>';
        }
        questionText += text;

        _.questionContainer.innerHTML = questionText;
    }
}

export default cmpQuestionContainer;
